<div class="content py-20">
    @if(isLoading()){
        <section class="svg-loader w-full f-main-center">
            <object data="old/cloudigo_loader.svg" type="image/svg+xml"></object>
        </section>
    } @else {
        <div class="manage-card">
            <mat-accordion class="paddingless-accordian-bodies">
    
                <!-- Account -->
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            @let acc_state = account_state();
                            <mat-icon [class.rotating]="acc_state.icon == 'autorenew'" [paint]="acc_state.paint">{{acc_state.icon}}</mat-icon>
                            <span>Account Details</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
    
                    <ng-container *ngTemplateOutlet="account_template()">
    
                    </ng-container>
                </mat-expansion-panel>
    
                <!-- Premium -->
                <mat-expansion-panel [expanded]="true">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            @let prm_state = premium_state();
                            <mat-icon [class.rotating]="prm_state.icon == 'autorenew'" [paint]="prm_state.paint">{{prm_state.icon}}</mat-icon>
                            <span>Premium</span>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
    
                    <!-- ? OUTLET FOR PREMIUM EXPASION PANEL -->
                    <ng-container *ngTemplateOutlet="premium_template()">
                    </ng-container>
                
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    }
</div>

<!--! Account States -->
@let s = state();
<ng-template #accountValid>
    <div class="card-content">
        <p class="m-0">
            Your account is up to date! Your details are valid and your communications are verified.
        </p>
    </div>
    <mat-divider></mat-divider>
    <mat-list>
        <mat-list-item>
            <a mat-flat-button class="basic-vertical" [disabled]="isLoading()" routerLink="/get-the-app">
                Get the app
            </a>
        </mat-list-item>
        <mat-list-item>
            <button mat-flat-button class="basic-vertical" [disabled]="isLoading()" (click)="promptEnterCode()">
                I have a Code
            </button>
        </mat-list-item>
    </mat-list>
</ng-template>

<ng-template #accountNotOptIn>
    <div class="card-content">
        <p class="m-0">
            Your account is missing some opt-ins. Opting in to our communications ensures you receive any news, updates and changes on our app!
        </p>
    </div>
    <mat-divider></mat-divider>
    <mat-list>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <a mat-flat-button class="premium-vertical" [disabled]="isLoading()" routerLink="/profile/preferences">
                    Manage Opt-ins
                </a>
            </div>
        </mat-list-item>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <a mat-flat-button class="basic-vertical" [disabled]="isLoading()" routerLink="/get-the-app">
                    Get the app
                </a>
                <button mat-flat-button class="basic-vertical" [disabled]="isLoading()" (click)="promptEnterCode()">
                    I have a Code
                </button>
            </div>
        </mat-list-item>
    </mat-list>
</ng-template>

<ng-template #accountNotVerified>
    <div class="card-content">
        <p class="m-0">
            Your account is not fully verified. Use the button below to complete email verification
        </p>
    </div>
    <mat-divider></mat-divider>
    <mat-list>
        <mat-list-item>
            <button mat-flat-button class="premium-vertical" [disabled]="isLoading()" (click)="verifyEmail()">
                Verify Email Address
            </button>
            <a mat-flat-button class="premium-vertical" [disabled]="isLoading()" routerLink="/profile/details">
                Change Email Address
            </a>
        </mat-list-item>
        <mat-list-item>
            <a mat-flat-button class="basic-vertical" [disabled]="isLoading()" routerLink="/get-the-app">
                Get the app
            </a>
            <button mat-flat-button class="basic-vertical" [disabled]="isLoading()" (click)="promptEnterCode()">
                I have a Code
            </button>
        </mat-list-item>
    </mat-list>
</ng-template>

<ng-template #accountMissingFields>
    <div class="card-content">
        <p class="m-0">
            Your account is missing some details. Use the button below to add the missing information.
        </p>
    </div>
    <mat-divider></mat-divider>
    <mat-list>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <a mat-flat-button class="premium-vertical" [disabled]="isLoading()" routerLink="/profile/details">
                    Enter missing details
                </a>
            </div>
        </mat-list-item>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <a mat-flat-button class="basic-vertical" [disabled]="isLoading()" routerLink="/get-the-app">
                    Get the app
                </a>
                <button mat-flat-button class="basic-vertical" [disabled]="isLoading()"(click)="promptEnterCode()">
                    I have a Code
                </button>
            </div>
        </mat-list-item>
    </mat-list>
</ng-template>

<!--! Premium States -->
@let membership = s?.membership;
@let transaction = s?.transaction;
@let use = s?.use;

<ng-template #premiumFree>
    <div class="card-content">
        <p class="m-0">
            You are currently not on any Premium Plan and are missing out on hundreds of discounts! Click <span class="font-semibold">Get Premium</span> to learn more about Premium.
        </p>
    </div>
    <mat-divider></mat-divider>
    <mat-list>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <a mat-flat-button class="premium-vertical" [disabled]="isLoading()" routerLink="/premium/yearly">
                    Get Premium
                </a>
            </div>
        </mat-list-item>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <button mat-flat-button class="basic-vertical" [disabled]="isLoading()" (click)="promptEnterCode()">
                    I have a Code
                </button>
            </div>
        </mat-list-item>
    </mat-list>
</ng-template>

<ng-template #premiumFreePending>
    <div class="card-content">
        <p class="m-0">
            You are currently not on any Premium Plan and are missing out on hundreds of discounts!
        </p>
        <p class="m-0">
            You currently have a pending transaction. 
        </p>
        <br/>
        <p class="m-0">
            @if(transaction?.error && transaction?.error != 'Payment Failed'){
                <span>
                    Last charge attempt
                    @if(transaction?.payment_method?.card; as card){
                        using
                        <ng-container *ngTemplateOutlet="shortCardPreview; context: { $implicit: card }"/>
                    }
                    failed with the error: 
                    <br/>
                    <span class="font-semibold" style="text-decoration: underline;">
                        {{transaction?.error}}
                    </span>
                    <br/><br/>
                </span>
            }
            Press <span class="font-semibold">Retry</span> below to re-attempt payment.
        </p>
    </div>
    <mat-divider></mat-divider>
    <mat-list>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <button mat-flat-button color="warn" [disabled]="isLoading" fancy vertical (click)="retryPayment()">
                    Retry Payment
                </button>
            </div>
        </mat-list-item>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <a mat-flat-button color="warn" [disabled]="isLoading" fancy vertical routerLink="/premium/yearly">
                    Start Over
                </a>
            </div>
        </mat-list-item>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <button mat-flat-button color="primary" [disabled]="isLoading" fancy vertical (click)="promptEnterCode(true)">
                    I have a new Code
                </button>
            </div>
        </mat-list-item>
    </mat-list>
</ng-template>

<ng-template #premiumPremium>
    <div class="card-content">
        <p class="m-0">
            You are currently on the 
            <span class="font-semibold">{{membership?.package?.name}}</span>. 
            @if(membership?.package?.slug == 'monthly'){
                <span>If you upgrade to the 
                <span class="font-semibold">cloudigo Premium Yearly Plan</span>, it will cost you less than paying 12 months on the Monthly Plan.</span>
            }
        </p>
        <br/>
        <p class="m-0">
            Your subscription has been active since <span class="font-semibold">{{membership?.start | date: 'dd/MM/yyyy'}}</span>. 
        </p>
        @if(membership?.expiry){
            @if(membership?.recurs){
                <p class="m-0">
                    Your next renewal date will be on <span class="font-semibold">{{membership?.expiry | date: 'dd/MM/yyyy'}}</span>, for <span class="font-semibold">€{{premium_state().metadata?.next_price}}</span>
                    @if(use){
                        <span> using code <span class="font-semibold">{{use?.code}}</span></span>.
                    }
                </p>
            } @else {
                <p class="m-0">
                    Your expiration date will be on <span class="font-semibold">{{membership?.expiry | date: 'dd/MM/yyyy'}}</span>. If you wish to renew again, <span class="font-semibold">Resubscribe</span> below.
                </p>
            }
        }
    </div>
    <mat-divider></mat-divider>
    <mat-list>
        @if(membership?.package?.slug == 'monthly'){
            <mat-list-item>
                <div class="f-cross-center cgap-8">
                    <a mat-flat-button class="premium-vertical" [disabled]="isLoading()" routerLink="/premium/checkout">
                        Upgrade to Yearly
                    </a>
                </div>
            </mat-list-item>
        }
        @if(!membership?.package?.recurs || membership?.recurs){
            <mat-list-item>
                <div class="f-cross-center cgap-8">
                    <button mat-flat-button class="premium-vertical" [disabled]="isLoading()" (click)="promptCardSelector()">
                        Manage Payment Method
                    </button>
                </div>
            </mat-list-item>
        }
        @if(membership?.package?.recurs && !membership?.recurs){
            <mat-list-item>
                <div class="f-cross-center cgap-8">
                    <button mat-flat-button class="premium-vertical" [disabled]="isLoading()" (click)="promptMembershipToggle()">
                        {{membership?.recurs ? 'Cancel Subscription' : 'Resubscribe'}}
                    </button>
                </div>
            </mat-list-item>
        }
    </mat-list>
</ng-template>

<ng-template #premiumPremiumProvided>
    <div class="card-content">
        <p class="m-0">
            You are currently on the <span class="font-semibold">{{membership?.package?.name}}</span>.
        </p>
        <br/>
        @if(membership?.package?.duration){
            <p class="m-0">
                Your plan does not expire but instead can end depending on your provider. 
            </p>
        } @else if(membership?.expiry) {
            <p class="m-0">
                Your expiration date will be on <span class="font-semibold">{{membership?.expiry | date: 'dd/MM/yyyy'}}</span>.
            </p>
        }
    </div>
</ng-template>

<ng-template #premiumPremiumPending>
    <div class="card-content">
        <p class="m-0">
            You are currently on the <span class="font-semibold">{{membership?.package?.name}}</span>.
        </p>
        <p class="m-0">
            You currently have a pending renewal from <span class="font-semibold">{{transaction?.created | date: 'dd/MM/yyyy'}}</span>, for <span class="font-semibold">€{{premium_state().metadata?.current_price}}</span>
            @if(transaction?.use; as use){
                <span> using code <span class="font-semibold">{{use.code}}</span></span>.
            }
        </p>
        <br/>
        <p class="m-0">
            @if(transaction?.error && transaction?.error != 'Payment Failed'){
                <span>
                    Last charge attempt
                    @if(transaction?.card; as card){
                        using
                        <ng-container *ngTemplateOutlet="shortCardPreview; context: { $implicit: card }"/>
                    }
                    failed with the error: 
                    <br/>
                    <span class="font-semibold" style="text-decoration: underline;">
                        {{transaction?.error}}
                    </span>
                    <br/><br/>
                </span>
            }
            Press <span class="font-semibold">Retry</span> below to re-attempt payment.
        </p>
    </div>
    <mat-divider></mat-divider>
    <mat-list>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <button mat-flat-button class="premium-vertical" [disabled]="isLoading()" (click)="retryPayment()">
                    Retry Payment
                </button>
            </div>
        </mat-list-item>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <button mat-flat-button class="premium-vertical" [disabled]="isLoading()" (click)="promptCardSelector(transaction?._id)">
                    Manage Payment Method
                </button>
            </div>
        </mat-list-item>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <button mat-flat-button class="basic-vertical" [disabled]="isLoading()" (click)="promptEnterCode(true)">
                    I have a new Code
                </button>
            </div>
        </mat-list-item>
    </mat-list>
</ng-template>

<ng-template #premiumPremiumPendingTruevo>
    <div class="card-content">
        <p class="m-0">
            You are currently on the <span class="font-semibold">{{membership?.package?.name}}</span>.
        </p>
        <p class="m-0">
            You currently have a pending renewal from <span class="font-semibold">{{transaction?.created | date: 'dd/MM/yyyy'}}</span>, for <span class="font-semibold">€{{account_state().metadata?.price}}</span>
            @if(transaction?.use; as use){
                <span> using code <span class="font-semibold">{{use.code}}</span></span>.
            }
        </p>
        <br/>
        <p class="m-0">
            <span>
                Last charge attempt has failed and you are required to re-enter your card details to continue.
            </span>
            <br/><br/>
            Press <span class="font-semibold">Retry</span> below to re-attempt payment.
        </p>
    </div>
    <mat-divider></mat-divider>
    <mat-list>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <button mat-flat-button class="premium-vertical" [disabled]="isLoading()" (click)="promptCardSelector()">
                    Retry Payment
                </button>
            </div>
        </mat-list-item>
        <mat-list-item>
            <div class="f-cross-center cgap-8">
                <button mat-flat-button class="basic-vertical" [disabled]="isLoading()" (click)="promptEnterCode(true)">
                    I have a new Code
                </button>
            </div>
        </mat-list-item>
    </mat-list>
</ng-template>

<ng-template #shortCardPreview let-card>
    <span class="card-info">
        @if(cardTypes.includes(card?.brand)){
            <img class="card-brand-img" src="old/payments/{{card?.brand || 'unknown'}}.svg" [alt]="card?.brand || 'unknown payment method'"/>

        } @else {
            <img class="card-brand-img card-brand-default" src="old/payments/unknown.png" alt="Unknown payment method"/>
        }
        <span>•••• {{card.last4}}</span>
        <!-- <span>|</span>
        <span>{{('0'+card.exp_month).slice(-2)}}/{{card.exp_year}}</span> -->
    </span>
</ng-template>


<ng-template #cardSelector let-ref="ref">
    <div class="px-8">
        <card-input ngSkipHydration (cardAdded)="onCardAction('add', ref, $event)" (cardUpdated)="onCardAction('update', ref, $event)" (cardSelected)="onCardAction('prefer', ref, $event)" (cardDeleted)="onCardAction('delete', ref, $event)"/>
    </div>
</ng-template>

<ng-template #codePrompt let-data let-ref="ref">
    <div class="ht-popup-content px-8">
        <div class="floating-control">
            <input matInput type="text" autocomplete="off" [formControl]="code" normal (keyup.enter)="submitCouponInput(data.from_pending, ref)"/>
        </div>
        <div class="field-info">
            @if(code.errors){
                <mat-error>
                    @if(code.hasError('coupon') && code.getError('coupon'); as couponError){
                        {{couponError}}
                    } @else {
                        Invalid Coupon
                    }
                </mat-error>
            } @else {
                <mat-hint>&nbsp;</mat-hint>
            }
        </div>
    </div>
</ng-template>